import PlantenCalculator from "./PlantenCalculator";
import LocatieVastleggen from "./LocatieVastleggen";
import {useState} from "react";

export default function ProductSidebarActions({
                                                  variant,
                                                  setProductQuantity = null,
                                                  setLonLatLocation,
                                                  setSetLocation,
                                              }) {

    const [openAction, setOpenAction] = useState('');

    return (
        <section className={'lg:col-start-10 lg:col-end-13 grid grid-cols-2 gap-4 mt-4'}>
            <PlantenCalculator
                setProductQuantity={setProductQuantity}
                selectedVariant={variant}
                openAction={openAction}
                setOpenAction={setOpenAction}
            />
            <LocatieVastleggen
                setLonLatLocation={setLonLatLocation}
                setSetLocation={setSetLocation}
                openAction={openAction}
                setOpenAction={setOpenAction}
            />
        </section>
    );
}